<template>
  <div class="code-radio">
    <el-radio-group class="zwx-radio-group" v-model="codeValue">
      <el-radio class="zwx-radio" v-for="item in simpleCodeList" :key="item.codeNo" :label="item.codeNo">{{ item.codeName }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'CodeRadio',
  model: {
    prop: 'simpleCodeValue',
    event: 'propEvent',
  },
  props: {
    codeType: { type: String },
    simpleCodeValue: { type: String },
    serviceName: { type: String, default: 'systematic' },
    apiSign: { type: Boolean, default: true },
    apiWhite: { type: Boolean, default: false },
  },
  data() {
    return {
      api: this.$store.state.api,
      simpleCodeList: [],
      codeValue: this.simpleCodeValue,
    }
  },
  mounted() {
    this.search()
  },
  watch: {
    simpleCodeValue(newValue) {
      this.codeValue = newValue
    },
    codeValue(newValue) {
      this.$emit('propEvent', newValue)
    },
  },
  methods: {
    search() {
      let data = {
        codeTypeCode: this.codeType,
      }
      this.$system.get(this.api + '/' + this.serviceName + '/getSimpleCodeListByCodeTypeCode-' + (this.apiWhite ? '0' : '1'), data, !this.apiWhite, this.apiSign, this.searchSuccess, this.searchError)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.simpleCodeList = data.simpleCodeList
      }
      this.$emit('loadOver')
    },
    searchError() {
      this.$emit('loadOver')
    },
    getSimpleCode() {
      if (this.codeValue === undefined || this.codeValue === null || this.codeValue === '') return null
      for (let i = 0, length = this.simpleCodeList.length; i < length; i++) {
        if (this.simpleCodeList[i].codeNo === this.codeValue) {
          return this.simpleCodeList[i]
        }
      }
      return null
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
